import { Controller } from "@hotwired/stimulus"

// While the member is onboarding, chrome triggers (the notifications bell)
// raise the red onboarding toast directly instead of opening a slideover the
// gate would immediately close — no flash of chrome (TASK-101.5 follow-up).
// Same message and styling as the server-side gate's toast.
export default class extends Controller {
  show() {
    window.toast?.("Please complete onboarding", { type: "error" })
  }
}
